import { chatGPT, mj, openai } from '@/config/model';

export default {
	name: 'UseRule',

	data() {
		return {
			chatGPT,
			openai
		};
	}
};